<!--
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2020-05-18 20:58:37
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/components/core/MqlLayout/MqlHeader/index.vue
--> 
<template>
  <div class="mql-header clearfix" :class="{background: background}">
    <div class="mql-header__left" :class="{'mql-header__left--full': fullwidth}">
      <slot></slot>
    </div>
    <div class="mql-header__right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MqlHeader",
  props: {
    background: Boolean,
    fullwidth: Boolean
  },
  computed: {}
};
</script>

<style lang='scss'>
.mql-header {
  padding: 10px 30px;
  .mql-header__left {
    position: relative;
    float: left;
    &.mql-header__left--full {
      float: none;
    }
  }
  .mql-header__right {
    float: right;
    .select-input > .el-input {
      width: 100px;
    }
    .el-input {
      width: 180px;
    }
  }
  &.background {
    background-color: rgba(0, 0, 0, 0.03);
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlHeader/index.vue